import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from '@/router'
import App from '@/App.vue'
import '@/assets/application.css'
import { initAmplitude } from '@/utils/amplitude'

const app = createApp(App)
app.use(createPinia())
app.use(router)
initAmplitude()

router.isReady().then(() => {
  app.mount('#app')
})
